import { CheckboxFilterComponent } from '@/shared/components/table/components/checkbox-filter/checkbox-filter.component';
import { PageDirection, TableDataSource } from "@/shared/components/table/table.model";
import { ElementDetailsGQL, ElementTag } from "@/core/graphql/graphql";
import { PaginatorComponent } from "@/shared/components/table/components/paginator/paginator.component";
import { SearchbarComponent } from "@/shared/components/table/components/searchbar/searchbar.component";
import { MatSort } from "@angular/material/sort";
import { FilterComponent } from "@/shared/components/table/components/filter/filter.component";
import { BehaviorSubject, Observable } from "rxjs";
import { CollectionViewer } from "@angular/cdk/collections";

export class ElementTagDatasource extends TableDataSource<ElementTag> {

  public paginator: PaginatorComponent;
  public searchbar: SearchbarComponent;
  public sort: MatSort;
  public filter: FilterComponent;
  private _elementsSubject = new BehaviorSubject<ElementTag[]>([]);

  public constructor(
    private readonly _elementDetailsGql: ElementDetailsGQL,
    private readonly _elementId: number,
  ) {
    super();
  }

  public set checkboxFilter(component: CheckboxFilterComponent) {}

  public connect(_: CollectionViewer): Observable<readonly ElementTag[]> {
    return this._elementsSubject.asObservable();
  }

  public disconnect(collectionViewer: CollectionViewer): void {
    this._elementsSubject.complete();
  }

  public onPaginationChange(requestedChange: PageDirection): void {
  }

  public loadData(): void {
    this._elementDetailsGql.fetch({
      id: this._elementId,
    }).subscribe((x) => {
      this._elementsSubject.next(x.data.element.tags?.items as ElementTag[]);
    });
  }
}
